import { createContext } from "react";

const SupplierContext = createContext();

export default SupplierContext;
